module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Enter the email address associated with your account\n            "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "id": "email",
      "required": "",
      "rules": [_vm.emailRule],
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reset()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reset.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aba8cfb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/PasswordResetRequest.vue
// module id = 441
// module chunks = 1